import { type Theme, type ThemeOptions, createTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"
import { componentsTheme } from "./componentsTheme"

export const buildTheme = (themeCreator: (theme: Theme) => ThemeOptions) =>
  createTheme(deepmerge(componentsTheme, themeCreator(componentsTheme)))
